/**
 * App chrome slice — top bar + sidebar footer labels.
 */
export const enChrome = {
  'topbar.searchPlaceholder': 'Search customers, orders, products…',
  'topbar.searchAria': 'Open search',
  'topbar.search': 'Search',
  'topbar.toggleMenu': 'Toggle menu',
  'topbar.userMenu': 'User menu',
  'topbar.account': 'Account',
  'topbar.settings': 'Settings',
  'topbar.integrations': 'Integrations',
  'topbar.gettingStarted': 'Getting Started',
  'topbar.logOut': 'Log out',
  'sidebar.account': 'Account',
  'sidebar.integrations': 'Integrations',
  'sidebar.logOut': 'Log out',
} as const;
